import styled, { css } from 'styled-components'

// const background = {
//     primary: 
// }

export default styled.section`
    ${props => props.zIndex && css`z-index: ${props.zIndex};`}
    ${props => props.height && css`height: ${props.height};`}
    ${props => props.backgroundColor && css`background-color: ${props.backgroundColor};`}
    ${'' /* min-height: 100vh; */}
    ${'' /* position: relative; */}
    width: 100%;
    ${'' /* grid-column-start: 1;
    grid-column-end: 4; */}
`